import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

import { PhxConstants, PhxLocalizationService } from '@common';
import { BaseComponentOnDestroy } from '@common/epics/base-component-on-destroy';
import { FormBuilder, FormGroup } from '@common/ngx-strongly-typed-forms/model';
import { UrlData } from '@common/services/urlData.service';

import { AppInitService } from '../../app-init.service';
import { AuthService } from '../../common/services/auth.service';
import { AccountModuleResourceKeys } from '../account-module-resource-keys';

export interface IAccessCodeLogin {
  accessCode: string;
}

@Component({
  selector: 'app-access-code',
  templateUrl: './access-code.component.html',
  styleUrls: ['./access-code.component.less'],
  standalone: false
})
export class AccessCodeComponent extends BaseComponentOnDestroy implements OnInit {

  form: FormGroup<IAccessCodeLogin>;

  loading: boolean = true;

  loginHideMessage: string;

  tokenObj: { IsExistingUser: boolean; token: string };

  loginFailedMessage: string;

  accountResourceKeys = AccountModuleResourceKeys;

  constructor(
    private fb: FormBuilder, 
    private authService: AuthService, 
    private localizationService: PhxLocalizationService, 
    private router: Router, 
    private route: ActivatedRoute, 
    private urlData: UrlData,
    private appInitService: AppInitService) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group<IAccessCodeLogin>({
      accessCode: [null, [
        Validators.required
      ]]
    });

    this.route.params.pipe(takeUntil(this.isDestroyed$)).subscribe(params => {
      this.loading = true;
      this.tokenObj = null;
      this.loginFailedMessage = null;
      this.loginHideMessage = null;

      const token = params.token;

      this.authService.validateAccessCodeToken(token)
        .pipe(takeUntil(this.isDestroyed$))
        .subscribe({
          next: (response) => {
            this.tokenObj = response;
            this.tokenObj.token = token;
            this.loading = false;
          },
          error: (ex => {
            if (ex.error?.Message) {
              this.loginHideMessage = ex.error.Message;
            } else {
              this.loginHideMessage = this.localizationService.translate(this.accountResourceKeys.accessCode.invalidToken);
            }
            this.loading = false;
          })
        });
    });
  }

  submit() {
    this.loginFailedMessage = null;

    this.authService.accessCode(this.form.value.accessCode, this.tokenObj.token)
      .then(response => {
        this.appInitService.initApp().then(() => {
          if (response.entityTypeId === PhxConstants.EntityType.TimeSheet) {
            this.urlData.setUrl('next/activity-centre');
            this.router.navigate([`next/timesheet/${response.entityId}`]);
          } else {
            this.router.navigate(['next/activity-centre']);
          }
        });
      })
      .catch(ex => {
        if (ex.error?.Message) {
          this.loginFailedMessage = ex.error.Message;
        } else {
          this.loginFailedMessage = this.localizationService.translate(this.accountResourceKeys.login.loginFailedMessage);
        }
      });
  }

}
